import Vue from 'vue';

// 需要在行内用三目判断的文本，false一定是--，没必要再使用filter过滤了。具体使用看src\views\camp\report\data-download\roster.vue
Vue.prototype.$nullText = '--'

// 文本为空时，显示--。具体使用看src\views\camp\report\data-download\roster.vue
Vue.filter('text', (value) => {
	return value ? value : '--'
})
